/*!
 * Main web js
 */

// variables
var web = window.web || {};
var dataLayer = window.dataLayer || [];
const ar = window.ar || {};

// functions

/*
get GA event data from attributes
if not mandatory items return false
return object with event data
*/
function getItemGaEventData(t) {
  var d = {};
  d.event = t.attr('data-ga-event');
  d.eventCategory = t.attr('data-ga-eventCategory');
  d.eventAction = t.attr('data-ga-eventAction');
  d.eventLabel = t.attr('data-ga-eventLabel');
  d.eventValue = t.attr('data-ga-eventValue');

  if (
    typeof d.event === 'undefined' ||
    d.event === '' ||
    typeof d.eventCategory === 'undefined' ||
    d.eventCategory === '' ||
    typeof d.eventAction === 'undefined' ||
    d.eventAction === ''
  ) {
    return false;
  }
  return d;
}

function scrollToSection($, id, space) {
  var topSpace = space || 0;
  var targetSec = $(
    '.block-item[data-section="' + id + '"], .menu-category-heading[data-section="' + id + '"]',
  );
  if (targetSec.length) {
    var offset = targetSec.offset();
    $('html,body').animate(
      { scrollTop: offset.top - ($('.main-nav').length ? $('.main-nav').height() : 0) - topSpace },
      800,
      function () {
        //
      },
    );
  }
}

function getnavposition($) {
  var pagePositionUrl;
  var scrollp = $(window).scrollTop();
  $('.block-item').each(function (index) {
    var offset = $(this).offset();
    var blockStart = offset.top - 200;
    var blockEnd = blockStart + $(this).height();

    var elemID = $(this).attr('data-section');
    if (typeof elemID !== 'undefined') {
      var menuelem = $('.main-nav-menu .nav-link[href$="#' + elemID + '"]');
      if (scrollp >= blockStart && scrollp < blockEnd) {
        menuelem.closest('.nav-item').addClass('active');
        if (pagePositionUrl !== elemID) {
          pagePositionUrl = elemID;
        }
      } else {
        menuelem.closest('.nav-item').removeClass('active');
      }
    }
  });
}

function mainNavigationPosition() {
  var html = $('html');
  var windowScroll = html[0].scrollTop;
  var wpAdminBar = $('#wpadminbar');
  var topSpan = 0 + wpAdminBar.height();
  var navigationSticky = $('#top-navigation-wrapper.sticky');
  var mastHead = $('#masthead');

  if (wpAdminBar) {
    navigationSticky.css({ top: topSpan });
  }

  if (windowScroll > 0) {
    html.addClass('top-navigation-sticked');
    navigationSticky.addClass('sticked');
    // mastHead.css({ paddingBottom: $('#top-navigation-wrapper.sticky').height() + 0 });
  } else {
    html.removeClass('top-navigation-sticked');
    navigationSticky.removeClass('sticked');
    // mastHead.css({ paddingBottom: 0 });
  }
}

function testValidEmail(email) {
  return /^[a-z_0-9.+-]+?@[a-z_0-9.-]+?\.[a-z_0-9.-]+?$/i.test(email);
}

function testIfEmpty(s) {
  return /^\s*$/i.test(s) || s === '';
}

// function gaUpdateElementEventData(t, d) {
//   if (d !== false) {
//     $.each(d, function(i, v) {
//       t.attr("data-ga-" + i, v);
//     });
//   }
// }

// lazyload
function lazyloadImages() {
  var lazyloadImagesList = $('img[data-src]');
  if (lazyloadImagesList.length) {
    var scrollTop = $(document).scrollTop();
    var viewPortH = window.innerHeight;
    lazyloadImagesList.each(function (i) {
      var t = $(this);
      var tTop = t.offset().top;
      if (tTop < scrollTop + viewPortH + 50) {
        t.attr('src', t.attr('data-src')).attr('data-src', null);
      }
    });
  }
}

// document ready
$(function () {
  // variables
  web.pageRollUp = $('.page-roll-up');

  // functions
  web.pageRollUpToggle = function () {
    if ($(window).scrollTop() > 500) {
      this.pageRollUp.addClass('show');
    } else {
      this.pageRollUp.removeClass('show');
    }
  }; /**/

  mainNavigationPosition();

  $('.main-navbar .nav-link, .scroll-to-link').click(function (e) {
    $('#main-nav-menu').collapse('hide');

    var t = $(this);
    var href = t.attr('href');
    var tUrl = new URL(href, window.location);
    var hrefUrl = tUrl.origin + tUrl.pathname;

    setTimeout(function () {
      var pageUrl = window.location.origin + window.location.pathname;

      if (hrefUrl === pageUrl && window.location.hash !== '') {
        var blockId = window.location.hash.slice(1);
        scrollToSection($, blockId);
      }
    }, 200);
  });

  // background seasson
  // winter 15.11. - 15.3.
  const currentDateMonth = new Date().getMonth();
  const currentDateDay = new Date().getDate();
  if (
    (currentDateMonth == 10 && currentDateDay >= 15) ||
    currentDateMonth == 11 ||
    (currentDateMonth >= 0 && currentDateMonth <= 1) ||
    (currentDateMonth == 2 && currentDateDay <= 15)
  ) {
    $('body').addClass('winter');
  } else {
    $('body').addClass('summer');
  }

  $('.food-menu-links a').click(function (e) {
    $('#main-nav-menu').collapse('hide');

    var t = $(this);
    var href = t.attr('href');
    var tUrl = new URL(href, window.location);
    var hrefUrl = tUrl.origin + tUrl.pathname;

    setTimeout(function () {
      var pageUrl = window.location.origin + window.location.pathname;

      if (hrefUrl === pageUrl && window.location.hash !== '') {
        var blockId = window.location.hash.slice(1);
        scrollToSection($, blockId, 50);
      }
    }, 200);
  });

  $(window).scroll(function () {
    getnavposition($);
  });

  if (window.location.hash !== '') {
    var blockId = window.location.hash.slice(1);
    setTimeout(function () {
      scrollToSection($, blockId);
    }, 1000);
  }

  web.pageRollUp.click(function () {
    $('html, body').stop().animate(
      {
        scrollTop: 0,
      },
      800,
    );
  });

  web.windowResize = function () {
    // $('.contact-map').height($(window).height() - $('.page-navigation').height());
  };

  /// GA events data

  // btn event click
  $('body').on('click', '.btn-click-ga-event', function (e) {
    var d = getItemGaEventData($(e.currentTarget));
    if (d !== false) {
      dataLayer.push(d); // push event data
    }
  });

  // /// registration form
  // web.regForm = {};
  // web.regForm.clearTime = null;
  // web.regForm.modal = $('.main-modal'); // modal
  // web.regForm.modalCloseBtn = '<span class="close" aria-label="Close"></span>'; // modal
  // // alert - error tmpl
  // web.regForm.errorMsgTmpl = function (msg) {
  //   var r = '';
  //   r += '<div class="alert alert-danger" role="alert">';
  //   r += msg;
  //   r += '</div>';
  //   return r;
  // };
  // // modal - update content
  // web.regForm.modal.on('keydown', function (e) {
  //   if (e.key === 'Escape' && web.regForm.modal.attr('data-escape').toString() === 'true') {
  //     web.regForm.modalClose();
  //   }
  // });
  // web.regForm.modalUpdate = function (html, opt) {
  //   var modalContent = '';
  //   if (this.clearTime) {
  //     clearTimeout(this.clearTime);
  //   }
  //   this.modalOptAdd(opt);
  //   if (opt.classRemove) {
  //     this.modal.removeClass(opt.classRemove);
  //   }
  //   if (opt.classAdd) {
  //     this.modal.addClass(opt.classAdd);
  //   }
  //   opt.closeBtn = typeof opt.closeBtn === 'undefined' ? true : opt.closeBtn;
  //   if (opt.closeBtn && opt.closeBtn !== false) {
  //     modalContent += this.modalCloseBtn;
  //   }
  //   modalContent += html;
  //   this.modal.find('.modal-content').html(modalContent);
  // };
  // // modal - call
  // web.regForm.modalCall = function (html, opt) {
  //   if (html) {
  //     this.modalUpdate(html, opt);
  //   }
  //   this.modal.modal('show');
  // };
  // // modal - close
  // web.regForm.modalClose = function () {
  //   // var that = this;
  //   this.modal.modal('hide');
  //   this.modal.data('bs.modal', null);
  //   // this.clearTime = setTimeout(function() {
  //   //   // web.regForm.modal.attr('class', 'modal main-modal');
  //   //   that.modalUpdate('', {
  //   //     // web.regForm.modalCloseBtn
  //   //     // classRemove: classRemove,
  //   //     backdrop: 'static',
  //   //     keyboard: false,
  //   //   });
  //   // }, 1000);
  // };
  // web.regForm.modal.on('hidden.bs.modal', function (e) {
  //   web.regForm.modal.attr('class', 'modal main-modal');
  //   web.regForm.modalUpdate('', {
  //     backdrop: 'static',
  //     keyboard: false,
  //   });
  // });
  // // modal - option remove
  // web.regForm.modalOptRemove = function () {
  //   this.modalOptAdd({});
  // };
  // // modal - option add/set
  // web.regForm.modalOptAdd = function (opt) {
  //   if (typeof opt.backdrop !== 'undefined') {
  //     this.modal.attr('data-backdrop', opt.backdrop);
  //   } else {
  //     this.modal.removeAttr('data-backdrop');
  //   }
  //   // if (typeof opt.keyboard !== 'undefined') {
  //   //   this.modal.attr('data-keyboard', opt.keyboard);
  //   // } else {
  //   //   this.modal.removeAttr('data-keyboard');
  //   // }
  //   this.modal.attr('data-keyboard', false);
  //   if (typeof opt.focus !== 'undefined') {
  //     this.modal.attr('data-focus', opt.focus);
  //   } else {
  //     this.modal.removeAttr('data-focus');
  //   }
  //   if (typeof opt.show !== 'undefined') {
  //     this.modal.attr('data-show', opt.show);
  //   } else {
  //     this.modal.removeAttr('data-show');
  //   }
  //   if (typeof opt.escape !== 'undefined') {
  //     this.modal.attr('data-escape', opt.escape);
  //   } else {
  //     this.modal.removeAttr('data-escape');
  //   }
  // };

  // // reg - modal call
  // $('body').on('click', '.registration-modal-btn', function () {
  //   var formHTML = $('.tmpl-registration-modal-form').html();
  //   // formHTML = $('<div>').append(formHTML);
  //   // gaUpdateElementEventData(formHTML.find('.form-submit'), gaEventData);
  //   // formHTML = formHTML.html();
  //   // console.log(formHTML);
  //   // var gaEventData = getItemGaEventData( $(this) );
  //   // console.log(gaEventData);
  //   web.regForm.gaDataLabel = $(this).attr('data-ga-event-reg-form-label');
  //   web.regForm.modalCall(formHTML, {
  //     classRemove: null,
  //     classAdd: 'registration-modal fade',
  //     // keyboard: false,
  //     escape: true,
  //   });
  // });
  // // reg - modal close
  // $('body').on('click', '.registration-modal .close', function () {
  //   web.regForm.modalClose(); // 'registration-modal fade'
  // });
  // // reg - input email remove error on type
  // $('body').on('keyup', 'form.error .input-item.error', function (e) {
  //   var t = $(e.currentTarget);
  //   var form = t.closest('.registration-form');
  //   t.removeClass('error');
  //   if (!form.find('.input-item.error').length) {
  //     form.removeClass('error');
  //     form.find('.form-msg .alert').fadeOut(200, function () {
  //       $(this).remove();
  //     });
  //   }
  // });
  // $('body').on('focus', '.input-item', function (e) {
  //   var t = $(e.currentTarget);
  //   t.addClass('focused');
  //   t.closest('.input-item-container').addClass('focused');
  // });
  // $('body').on('blur', '.input-item', function (e) {
  //   var t = $(e.currentTarget);
  //   t.removeClass('focused');
  //   t.closest('.input-item-container').removeClass('focused');
  // });
  // $('body').on('keyup keypress blur', '.input-item', function (e) {
  //   var t = $(e.currentTarget);
  //   var text = t.val();
  //   var textLength = text.length;
  //   if (textLength) {
  //     t.addClass('typed');
  //     t.closest('.input-item-container').addClass('typed');
  //   } else {
  //     t.removeClass('typed');
  //     t.closest('.input-item-container').removeClass('typed');
  //   }
  // });
  // reg - submit form
  // $('body').on('submit', '.registration-form', function(e) {
  //   e.preventDefault();
  //   var t = $(this); // form
  //   var submitBtn = t.find('.form-submit');
  //   var gaEventData = getItemGaEventData(submitBtn);
  //   var regForm = t; // t.closest('.registration-form');// form
  //   var regName = regForm.find('input[name="reg_name"]').val();
  //   var regEmail = regForm.find('input[name="reg_email"]').val();

  //   // if (typeof web.regForm.gaDataLabel !== 'undefined' && web.regForm.gaDataLabel !== false) {
  //   //   gaEventData.eventLabel = web.regForm.gaDataLabel;
  //   // }
  //   // console.log('form submit event data: ', gaEventData);

  //   if (
  //     regName &&
  //     !testIfEmpty(regName) &&
  //     regEmail &&
  //     !testIfEmpty(regEmail) &&
  //     testValidEmail(regEmail)
  //   ) {
  //     // show modal loading
  //     var formHTML = $('.tmpl-registration-modal-loading').html();
  //     web.regForm.modalCall(formHTML, {
  //       classRemove: null,
  //       classAdd: 'registration-modal fade',
  //       keyboard: false,
  //       closeBtn: false,
  //       backdrop: 'static',
  //     });

  //     // email send data
  //     $.post(
  //       'ajax/registration-request.php',
  //       {
  //         name: regName,
  //         email: regEmail,
  //         lang: web.lang,
  //       },
  //       function(data) {
  //         // console.log( data );
  //         switch (data.response.status) {
  //           case 0: // OK
  //             formHTML = $('.tmpl-registration-modal-done').html();
  //             web.regForm.modalUpdate(formHTML, {
  //               classRemove: null,
  //               classAdd: 'registration-modal fade',
  //             });
  //             regForm[0].reset();
  //             if (gaEventData !== 'false') {
  //               dataLayer.push(gaEventData); // push event data
  //             }
  //             // registration link
  //             if (data.response.signInLink) {
  //               var signInLink = data.response.signInLink;
  //               formHTML = formHTML.replace('___REGISTRATIONSIGNINLINK___', signInLink);
  //               setTimeout(function() {
  //                 window.location.href = signInLink;
  //               }, 200);
  //             }
  //             break;
  //           case 2: // already registered
  //             formHTML = $('.tmpl-registration-modal-registered').html();
  //             web.regForm.modalUpdate(formHTML, {
  //               classRemove: null,
  //               classAdd: 'registration-modal fade',
  //             });
  //             break;

  //           default:
  //             // error
  //             formHTML = $('.tmpl-registration-modal-error').html();
  //             web.regForm.modalUpdate(formHTML, {
  //               classRemove: null,
  //               classAdd: 'registration-modal fade',
  //             });
  //             break;
  //         }
  //       },
  //     );
  //   } else {
  //     var erMsgTmpl = $('.tmpl-registration-alert-err-email').html();
  //     var erMsg = $(erMsgTmpl);
  //     var erMsgContainer = regForm.find('.form-msg');

  //     regForm.addClass('error');
  //     // name validation error
  //     if (testIfEmpty(regName)) {
  //       var nameInput = regForm.find("input[name='reg_name']");
  //       nameInput.addClass('error');
  //     }
  //     // email validation error
  //     if (!testValidEmail(regEmail)) {
  //       var emailInput = regForm.find("input[name='reg_email']");
  //       emailInput.addClass('error');
  //     }

  //     erMsgContainer.html(erMsg);

  //     // setTimeout(function() {
  //     //   erMsg.fadeOut(2000, function() {
  //     //     $(this).remove();
  //     //   });
  //     // }, 2000);
  //   }
  // });

  // var hpIntroCarousel = $('.hp-intro-carousel');
  // hpIntroCarousel
  //   .on('init', function(event, slick) {
  //     $(slick.$slides[0]).addClass('hpic-item-active');
  //   })
  //   .on('reInit', function(event, slick) {
  //     // console.log('reInit');
  //   })
  //   .slick({
  //     centerMode: true,
  //     centerPadding: '0',
  //     slidesToShow: 1,
  //     variableWidth: true,
  //     arrows: false,
  //     dots: false,
  //     infinite: true,
  //     speed: 300,
  //     lazyLoad: 'progressive', // progressive | ondemand
  //     // autoplay: true,
  //     // autoplaySpeed: 3000,
  //     // pauseOnFocus: true,
  //     // pauseOnHover: true,
  //     responsive: [
  //       {
  //         breakpoint: 992,
  //         settings: {
  //           variableWidth: false,
  //           centerPadding: '20px',
  //         },
  //       },
  //     ],
  //   });
  // // hp carousel events
  // hpIntroCarousel.on('afterChange', function() {
  //   // hpIntroCarousel.find('.hpic-item.slick-active').addClass('hpic-item-active');
  // });
  // hpIntroCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  //   // console.log(event, slick, currentSlide, nextSlide);
  //   // console.log(slick);
  //   // console.log(currentSlide, $(slick.$slides[currentSlide]), nextSlide, $(slick.$slides[nextSlide]));
  //   $(slick.$slides[currentSlide]).removeClass('hpic-item-active');
  //   $(slick.$slides[nextSlide]).addClass('hpic-item-active');

  //   // console.log('next', nextSlide, slick.$slides.length);
  //   // if (nextSlide === slick.$slides.length - 1) {
  //   //   console.log('ënd');
  //   //   $(slick.$slides[currentSlide])
  //   //     .next()
  //   //     .addClass('hpic-item-active');
  //   // }
  //   // hpIntroCarousel.find('.hpic-item').removeClass('hpic-item-active');
  //   // currentSlide.removeClass('hpic-item-active');
  // });
  // // hp carousel nav
  // hpIntroCarousel.on('click', '.item-nav-next', function() {
  //   hpIntroCarousel.slick('slickNext');
  // });
  // hpIntroCarousel.on('click', '.item-nav-prev', function() {
  //   hpIntroCarousel.slick('slickPrev');
  // });
  // hpIntroCarousel.on('click', '.hpic-item', function() {
  //   var t = $(this);
  //   var active = hpIntroCarousel.find('.hpic-item.slick-active');
  //   if (t[0] === active.next()[0]) {
  //     hpIntroCarousel.slick('slickNext');
  //   }
  //   if (t[0] === active.prev()[0]) {
  //     hpIntroCarousel.slick('slickPrev');
  //   }
  // });
  // hpIntroCarousel.on('hover', function() {});

  $('.block-gallery a').simpleLightbox();

  $(window).scroll(); // initial scroll call

  // on scroll actions
  $(window).scroll(function () {
    web.pageRollUpToggle();
    lazyloadImages();

    mainNavigationPosition();

    // $('.page-side-in').each(function() {
    //   var scrollTop = $('html')[0].scrollTop;
    //   var elementGap = 20;
    //   var container = $(this);
    //   var banner = $(this).find('.page-side-banner');
    //   var bannerPosition = banner.css('top');

    //   // console.log(scrollTop);
    //   // console.log(container.height());

    //   // zero position
    //   if (scrollTop < container.offset().top - elementGap) {
    //     bannerPosition = 0;
    //   }
    //   // follow position
    //   if (
    //     scrollTop > container.offset().top - elementGap &&
    //     scrollTop < container.offset().top + container.height()
    //   ) {
    //     bannerPosition = scrollTop - container.offset().top + elementGap;
    //   }
    //   // stop position
    //   if (scrollTop > container.offset().top + container.height() - banner.height()) {
    //     bannerPosition = container.height() - banner.height();
    //   }

    //   banner.css({
    //     top: bannerPosition,
    //   });
    // });

    // $('.slowparalax').each(function() {
    //   var t = $(this);
    //   var scrollingParent = $('html')[0];
    //   var tTop = t.offset().top;
    //   t.css({
    //     'background-position': 'center ' + (scrollingParent.scrollTop - tTop) / 3 + 'px',
    //   });
    // });
  });

  // on resize actions
  web.windowResize();
  $(window).resize(function () {
    web.windowResize();
  });
});

// cookies consent management --------------
ar.docReady(function () {
  ar.cookiesConsent();
});
